import Logo from "./Logo";
import type { LogoProps } from "./Logo.d";

export { Logo };
export type { LogoProps };
